import React, { Fragment, useEffect, useState } from "react";
import LoadingPage from "../TESTPage/LoadingPage";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  FormText,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import ModalUser from "../SetData/SetCommander/ModalUser";
import { useInsertConText } from "../Context/InsertContext";
import { FetchAxiosFile } from "../../api/axios";
import { GetCookieToken } from "../Cookie/GetCookie";
import axios from "axios";
import { CheckPosition } from "../Function/CheckPosition";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import ConfirmModal from "../../components/Common/ConfirmModal";

const API_URL = process.env.REACT_APP_API_CORS;

function UploadSlipMoney(props) {
  const {userInfo} = props
  const navigate = useNavigate();
  const { insert, setInsert } = useInsertConText();
  const token = GetCookieToken("userToken");
  const [alertFileSubmit, setAlertFileSubmit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [fileUp, setFileUp] = useState(null);
  const [alertFile, setAlertFile] = useState(false);
  const [showFile, setShowFile] = useState(false);
  const [userName, setUserName] = useState(null);
  const [userID, setUserID] = useState(null);
  const [confirmModal, setconfirmModal] = useState(false)

  const fetchUserData = () => {
    const url = `${API_URL}/api/users/position/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 1,
      "order[0]": "position_id",
      "order[1]": "DESC",
      "filter[assign][0]": "0",
      "filter[org_id][0]": "148",
      "filter[position_id][0]": "7",
    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    axios
      .get(url, config)
      .then(response => {
        setUserID(String(response.data.result.map(i => i.user_id)));
        setUserName(String(response.data.result.map(i => i.user_name)));
        // const userId = response.data.result?.map(i => i.user_id);
      })
      .catch(error => console.error("Error:", error));
  };

  const handleButtonFileClick = () => {
    const fileInput = document.getElementById("file-input");

    if (fileInput) {
      fileInput.click();
    }
  };

  const handleFileChange = e => {
    const file = e.target.files[0];

    if (file) {
      setFileUp(file);
      setShowFile(true);
      setAlertFile(false);
    }
  };

  const handleClearFile = e => {
    const fileInput = document.getElementById("file-input");
    if (fileInput) {
      setShowFile(false);
      fileInput.value = null;
      setFileUp(null);
    }
  };

  useEffect(() => {
    if (insert.task === "user_ผู้บังคับบัญชา") {
      setUserID(insert.insert_id);
      setUserName(insert.insert_name);
    }
  }, [insert]);

  const handleSubmit = () => {
    if (fileUp !== null) {
      setLoading(true);
      setAlertFileSubmit(false);
      const url_file = "/api/salary/upload";
      // const url_file = "/api/salary/increase/upload";
      FetchAxiosFile(url_file, token, fileUp);
      setFileUp(null);
      setAlertFile(false);
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    } else {
      setAlertFileSubmit(true);
    }
  };

  useEffect(() => {
    fetchUserData();
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);

  const onDismiss = () => setAlertFileSubmit(false);

  // useEffect(() => {
  //   if (userInfo) {
  //     if (
  //       !CheckPosition(userInfo?.position) &&
  //       !CheckSubAdmin(userInfo?.positionSubAdmin)
  //     ) 
  //     {
  //       navigate("/setdata");
  //     }
  //   }
  // }, [userInfo]);

  return (
    <Fragment>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
          }}
        >
          <LoadingPage />
        </div>
      ) : (
        <FadeIn>
          {/* <h4>นำเข้าไฟล์เงินเดือน</h4> */}
          <Card>
            <CardBody>
              <Form onSubmit={e => { e.preventDefault(); setconfirmModal(true) }}>
                <Row>
                  <Col lg={6}>
                    <FormGroup>
                      <Label>ผู้มีหน้าที่จ่ายเงิน</Label>
                      <InputGroup>
                        <Input
                          disabled
                          defaultValue={userName}
                          name="payer_name"
                          placeholder=""
                          type="text"
                          invalid={!userName}
                        />
                        <ModalUser task="user_ผู้บังคับบัญชา" disbleButton = {true} />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg={2}>
                    <FormGroup>
                      <Label>เลือกไฟล์เอกสาร</Label>
                      <br />
                      <Button type="button" onClick={handleButtonFileClick}>
                        <i className="fa-solid fa-upload pe-2"></i> อัพโหลดไฟล์
                      </Button>
                      <input id="file-input" type="file" 
                      // accept=".txt*" 
                      style={{ display: "none" }} onChange={handleFileChange}/>
                      <br />
                      <FormText color="danger" style={{ fontSize: "12px" }} className="text-nowrap">*อัพโหลดได้เฉพาะไฟล์ txt เท่านั้น</FormText>
                    </FormGroup>
                  </Col>

                  {fileUp !== null ? (
                    <Col lg={4}>
                      <br />
                      <Alert color="info" isOpen={showFile} >
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <i className="fa-solid fa-file-lines fa-2xl text-primary"></i>
                          </Col>
                          <Col>
                            <span to="#" className="text-primary"> {fileUp.name} </span>
                            <p className="mb-0"> <strong>{fileUp.formattedSize}</strong> </p>
                          </Col>
                          <Col className="col-auto">
                            <button type="button" className="btn btn-link btn-sm text-danger" onClick={() => { handleClearFile() }}>
                              <i className="fa-solid fa-xmark-large"></i>
                            </button>
                          </Col>
                        </Row>
                      </Alert>
                    </Col>
                  ) : (
                    ""
                  )}
                  {alertFile === true ? (
                    <Row className="mb-2">
                      <Col lg={12}>
                        <div id="liveAlertPlaceholder">
                          <Alert color="danger" className="text-danger" isOpen={alertFile}>
                            กรุณาอัพโหลดไฟล์เงินเดือน
                          </Alert>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  <Col lg={6}></Col>
                </Row>
                <Button color="success" type="submit">
                  บันทึก
                </Button>
                {alertFileSubmit ? (
                  <Row className="mb-2 mt-2">
                    <Col lg={6}>
                      <Alert color="danger" className="text-danger" isOpen={alertFileSubmit} toggle={onDismiss}>
                        กรุณาอัพโหลดไฟล์เงินเดือน
                      </Alert>
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
              </Form>
            </CardBody>
          </Card>
          <ConfirmModal
            modal = {confirmModal}
            modalSize = "md"
            modalHeaderContent = "คุณต้องการที่จะเพิ่มไฟล์เงินเดือน ใช่หรือไม่?"
            onClickConfirmBtn={() => {
              handleSubmit();
              setconfirmModal(false)
            }}
            onClickCancelBtn={() => {
            setconfirmModal(false)
            }}
          />
        </FadeIn>
      )}
    </Fragment>
  );
}

export default UploadSlipMoney;
